import React, {useState, useEffect} from 'react';
import { NavLink } from "react-router-dom";
import './Navbar.scss';

import MenuNav from './Menu/MenuNav.js';

function Navbar(props) {
    let [menuOpen, setMenuOpen] = useState(false)

    function handleMenuClick(link) {
        setMenuOpen(!menuOpen)
        let behavior = 'smooth';
        if(link.includes('/#')){
            document.getElementById(link.split('/#')[1]).scrollIntoView({ behavior: behavior});
          }else{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              })
          }
    }
    function handleMenuClick(link) {
        setMenuOpen(false)
        let behavior = 'smooth';
        if(link.includes('/#')){
            document.getElementById(link.split('/#')[1]).scrollIntoView({ behavior: behavior});
          }else{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              })
          }
    }
    // function handleLinkClick(link) {
    //     setMenuOpen(false);
        
    //     // window.location.href = link
    //     let stateObj = { id: "100" };
              
    //           window.history.replaceState(stateObj,
    //                   "Page", link);
    //         console.log(link)
    //     if(link.includes('/#')){
    //       console.log(document.getElementById(link.split('/#')[1]))
    //       document.getElementById(link.split('/#')[1]).scrollIntoView();
    //     }else{
    //       window.scrollTo({
                // top: 0,
                // left: 0,
                // behavior: "smooth",
            //   })
    //     }
    //   }

    // Nav item list

    let nav_item_list = [
        {name:'Home', link:'/#home'},
        {name:'About', link:'/#about'},
        {name:'Services', link:'/#services'},
        {name:'Testimonals', link:'/#testimonials'},
        // {name:'Softball Lessons', link:'/lessons'},
        // {name:'Meet The Coaches', link:'/meetthecoach'},
        {name:'Contact', link:'/#contact'}

    ]

    return (
        <div className="Navbar">
            <svg height="60px" width="60px" version="1.1" id="Layer_Pedal" 
                    viewBox="0 0 512 512" >
                <g>
                    <path fill="#f89f73" d="M155.566,349.301C223.442,388.489,256,459.171,256,459.171s-77.49,7.145-145.367-32.044
                        S10.199,317.257,10.199,317.257S87.69,310.112,155.566,349.301z"/>
                    <path fill="#f89f73" d="M401.367,427.127C333.49,466.315,256,459.171,256,459.171s32.558-70.681,100.434-109.87
                        s145.367-32.044,145.367-32.044S469.243,387.938,401.367,427.127z"/>
                </g>
                <g>
                    <path fill="#7fb98d" d="M220.353,297.381C263.948,372.891,256,459.097,256,459.097s-78.631-36.219-122.226-111.729
                        S98.126,185.652,98.126,185.652S176.757,221.871,220.353,297.381z"/>
                    <path fill="#7fb98d" d="M378.226,347.367C334.631,422.878,256,459.097,256,459.097s-7.948-86.206,35.647-161.716
                        s122.226-111.73,122.226-111.73S421.822,271.857,378.226,347.367z"/>
                </g>
                <g>
                    <path fill="#f89f73" d="M307.396,296.772c0,89.65-51.396,162.325-51.396,162.325s-51.396-72.675-51.396-162.324
                        S256,134.447,256,134.447S307.396,207.123,307.396,296.772z"/>
                    <circle fill="#f89f73" cx="173.386" cy="159.883" r="19.888"/>
                    <circle fill="#f89f73" cx="338.613" cy="159.883" r="19.888"/>
                </g>
                <circle fill="#7fb98d" cx="256" cy="72.17" r="19.888"/>
                <path d="M510.633,312.157c-1.655-2.867-4.6-4.753-7.896-5.057c-2.145-0.197-47.182-4.084-99.312,11.3
                    c26.328-66.804,20.892-130.565,20.604-133.685c-0.304-3.296-2.189-6.241-5.057-7.896c-2.867-1.655-6.359-1.816-9.367-0.43
                    c-2.376,1.094-53.024,24.801-96.25,73.73c-12.294-68.888-47.239-119.028-49.03-121.56c-1.911-2.703-5.016-4.31-8.328-4.31
                    s-6.416,1.607-8.328,4.31c-1.791,2.531-36.734,52.671-49.03,121.56c-43.226-48.93-93.874-72.636-96.25-73.73
                    c-3.006-1.385-6.5-1.225-9.367,0.43c-2.867,1.655-4.753,4.6-5.057,7.896c-0.289,3.121-5.725,66.883,20.604,133.687
                    c-52.132-15.383-97.17-11.499-99.31-11.302c-3.296,0.304-6.241,2.19-7.896,5.057s-1.816,6.359-0.43,9.367
                    c1.384,3.007,34.718,74.09,104.598,114.435c51.68,29.838,107.921,33.957,135.047,33.957c7.857,0,13.268-0.346,15.42-0.512
                    c2.152,0.167,7.56,0.512,15.42,0.512c27.128,0,83.37-4.122,135.047-33.957c69.88-40.345,103.213-111.428,104.598-114.435
                    C512.45,318.518,512.288,315.024,510.633,312.157z M404.223,202.381c-0.037,27.613-4.169,86.782-34.829,139.886
                    c-24.03,41.622-59.583,71.06-85.315,88.497c15.173-30.599,33.517-78.964,33.517-133.994c0-6.372-0.254-12.652-0.713-18.829
                    C346.514,239.109,384.222,213.977,404.223,202.381z M256,153.757c14.113,24.479,41.197,79.709,41.197,143.016
                    S270.11,415.312,256,439.788c-14.113-24.479-41.197-79.709-41.197-143.016S241.889,178.233,256,153.757z M195.118,277.942
                    c-0.459,6.178-0.713,12.457-0.713,18.83c0,55.065,18.368,103.46,33.547,134.055c-25.71-17.401-61.246-46.817-85.345-88.559
                    c-30.576-52.959-34.747-112.22-34.81-139.876C127.804,213.995,165.496,239.122,195.118,277.942z M27.042,326.964
                    c19.957,0.158,56.079,2.755,93.151,16.865c1.516,2.888,3.091,5.771,4.748,8.639c26.426,45.771,64.75,77.386,92.361,95.908
                    c-27.567-2.383-66.147-9.63-101.569-30.082C69.434,391.563,39.962,348.875,27.042,326.964z M396.267,418.294
                    c-35.422,20.45-74.002,27.698-101.568,30.081c27.61-18.522,65.934-50.137,92.359-95.907c1.656-2.869,3.233-5.752,4.75-8.642
                    c36.96-14.064,73.145-16.67,93.138-16.844C472.018,348.904,442.55,391.572,396.267,418.294z"/>
                <path d="M173.386,189.972c16.59,0,30.088-13.498,30.088-30.088s-13.498-30.088-30.088-30.088s-30.088,13.498-30.088,30.088
                    S156.796,189.972,173.386,189.972z M173.386,150.195c5.342,0,9.689,4.347,9.689,9.689c0,5.342-4.347,9.689-9.689,9.689
                    s-9.689-4.347-9.689-9.689C163.697,154.542,168.044,150.195,173.386,150.195z"/>
                <path d="M338.613,189.972c16.59,0,30.088-13.498,30.088-30.088s-13.498-30.088-30.088-30.088s-30.088,13.498-30.088,30.088
                    S322.023,189.972,338.613,189.972z M338.613,150.195c5.342,0,9.689,4.347,9.689,9.689c0,5.342-4.347,9.689-9.689,9.689
                    s-9.689-4.347-9.689-9.689C328.924,154.542,333.271,150.195,338.613,150.195z"/>
                <path d="M256,102.259c16.59,0,30.088-13.498,30.088-30.088S272.59,42.083,256,42.083s-30.088,13.498-30.088,30.088
                    S239.41,102.259,256,102.259z M256,62.482c5.342,0,9.689,4.347,9.689,9.689c0,5.342-4.347,9.689-9.689,9.689
                    s-9.689-4.347-9.689-9.689C246.311,66.829,250.657,62.482,256,62.482z"/>
                <path d="M256.501,393.704c1.303,0.555,2.659,0.818,3.993,0.818c3.964,0,7.735-2.326,9.388-6.204
                    c0.108-0.255,1.105-2.614,2.578-6.823c1.862-5.316-0.938-11.135-6.254-12.998c-5.316-1.86-11.134,0.938-12.998,6.254
                    c-1.253,3.578-2.09,5.565-2.094,5.572C248.906,385.506,251.318,391.497,256.501,393.704z"/>
                <path d="M269.164,357.242c0.677,0.136,1.351,0.201,2.017,0.201c4.759,0,9.016-3.349,9.989-8.195
                    c3.899-19.434,5.567-38.908,4.957-57.884c-0.181-5.63-4.905-10.05-10.522-9.866c-5.63,0.181-10.047,4.892-9.866,10.521
                    c0.56,17.412-0.977,35.317-4.569,53.215C260.062,350.758,263.641,356.133,269.164,357.242z"/>
                </svg> 
            <nav className={'Navbar-items'}>
 
                {nav_item_list.map((item) => {
                    
                    return <NavLink to={item.link} onClick={()=>{ handleMenuClick(item.link);}}>
                        {item.name}
                    </NavLink>
                })}
            </nav>
            <div className={`menu-div`}>
                <MenuNav {...props} nav_item_list={nav_item_list}/>
            </div>
        </div>
    );
}

export default Navbar;
